import axios from "axios";
import { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import BeaconModel from "../model/BeaconModel";
import ExcelJS from 'exceljs';
import iBS02IR_ResultType from "../model/iBS02IR_ResultType";
import iBS02PIR_ResultType from "../model/iBS02PIR_ResultType";
import iBS03R_ResultType from "../model/iBS03R_ResultType";
import iBS03T_ResultType from "../model/iBS03T_ResultType";
import iBS05H_ResultType from "../model/iBS05H_ResultType";
import iBS03ADV_ResultType from "../model/iBS03ADV_ResultType";
import salta_ResultType from "../model/salta_ResultType";
import iBS03TP_ResultType from "../model/iBS03TP_ResultType";
import iBS03F_ResultType from "../model/iBS03F_ResultType";
import SensorLog_iBS02IR_Result from "../components/SensorLog_iBS02IR_Result";
import SensorLog_iBS02PIR_Result from "../components/SensorLog_iBS02PIR_Result";
import SensorLog_iBS03R_Result from "../components/SensorLog_iBS03R_Result";
import SensorLog_iBS03T_Result from "../components/SensorLog_iBS03T_Result";
import SensorLog_iBS05H_Result from "../components/SensorLog_iBS05H_Result";
import SensorLog_iBS03ADV_Result from "../components/SensorLog_iBS03ADV_Result";
import SensorLog_salta_Result from "../components/SensorLog_salta_Result";
import SensorLog_iBS03TP_Result from "../components/SensorLog_iBS03TP_Result";
import SensorLog_iBS03F_Result from "../components/SensorLog_iBS03F_Result";
import "./SensorLog.css";

const SensorLog = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [model, setModel] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("1000");
    const [macaddress, setMacaddress] = useState<string>("");
    const [rssi_gt, setRssi_gt] = useState<string>("");
    const [rssi_lt, setRssi_lt] = useState<string>("");
    const [detected_gt, setDetcted_gt] = useState<string>("");
    const [detected_lt, setDetcted_lt] = useState<string>("");
    const [arrived_gt, setArrived_gt] = useState<string>("");
    const [arrived_lt, setArrived_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);

    const [iBS02IRResult, setIBS02IRResult] = useState<iBS02IR_ResultType[]>([]);
    const [iBS02PIRResult, setIBS02PIRResult] = useState<iBS02PIR_ResultType[]>([]);
    const [iBS03RResult, setIBS03RResult] = useState<iBS03R_ResultType[]>([]);
    const [iBS03TResult, setIBS03TResult] = useState<iBS03T_ResultType[]>([]);
    const [iBS05HResult, setIBS05HResult] = useState<iBS05H_ResultType[]>([]);
    const [iBS03ADVResult, setIBS03ADVResult] = useState<iBS03ADV_ResultType[]>([]);
    const [saltaResult, setSaltaResult] = useState<salta_ResultType[]>([]);
    const [iBS03TPResult, setIBS03TPResult] = useState<iBS03TP_ResultType[]>([]);
    const [iBS03FResult, setIBS03FResult] = useState<iBS03F_ResultType[]>([]);

    const [iBS02IRCsvResult, setIBS02IRCsvResult] = useState<iBS02IR_ResultType[]>([]);
    const [iBS02PIRCsvResult, setIBS02PIRCsvResult] = useState<iBS02PIR_ResultType[]>([]);
    const [iBS03RCsvResult, setIBS03RCsvResult] = useState<iBS03R_ResultType[]>([]);
    const [iBS03TCsvResult, setIBS03TCsvResult] = useState<iBS03T_ResultType[]>([]);
    const [iBS05HCsvResult, setIBS05HCsvResult] = useState<iBS05H_ResultType[]>([]);
    const [iBS03ADVCsvResult, setIBS03ADVCsvResult] = useState<iBS03ADV_ResultType[]>([]);
    const [saltaCsvResult, setSaltaCsvResult] = useState<salta_ResultType[]>([]);
    const [iBS03TPCsvResult, setIBS03TPCsvResult] = useState<iBS03TP_ResultType[]>([]);
    const [iBS03FCsvResult, setIBS03FCsvResult] = useState<iBS03F_ResultType[]>([]);

    const [beaconResult, setBeaconResult] = useState<BeaconModel[]>([]);

    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    const [isNamaCheck, setNameCheck] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);   // CSV全件取得
    const [isFetching, setIsFetching] = useState<boolean>(false); // 検索・ページング

    // ---- UI-only state ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    var apiUrl: string = "";

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/sensor_logs"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/sensor_logs"
      }
    }

    const getSensorLogs = async(e: any, pageNo: number) => {
        e.preventDefault();

        // 各種Resultをクリア
        setIBS02IRResult([]);
        setIBS02PIRResult([]);
        setIBS03RResult([]);
        setIBS03TResult([]);
        setIBS05HResult([]);
        setIBS03ADVResult([]);
        setSaltaResult([]);
        setIBS03TPResult([]);
        setIBS03FResult([]);

        if (per_page === "") {
          setPer_Page("1000")
        }
        saveParams();
        saveApikey();
        checkLocoEnv();

        setIsFetching(true);
        try {
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(model ? {model: model} : {}),
              ...(macaddress ? {macaddress: macaddress} : {}),
              ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
              ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
              ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
              ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
              ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
              ...(arrived_lt ? {arrived_lt: arrived_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }

          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            if (pageNo === 0) {
              alert("10万件を超えるデータは表示出来ません\n10万件までのデータを表示します\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            }
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(getLastPageNo())
          } else {
            setTotal(items.total)
            setPageNo(items.current_page)
            setLastPageNo(items.last_page)
          }

          // モデルごとに型を分岐
          switch(model) {
            case "iBS02IR":
              const irResults: iBS02IR_ResultType[] = [];
              items.data.forEach((value: iBS02IR_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                irResults.push(value);
              });
              setIBS02IRResult(irResults);
              break;
            case "iBS02PIR":
              const pirResults: iBS02PIR_ResultType[] = [];
              items.data.forEach((value: iBS02PIR_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                pirResults.push(value);
              });
              setIBS02PIRResult(pirResults);
              break;
            case "iBS03R":
              const rResults: iBS03R_ResultType[] = [];
              items.data.forEach((value: iBS03R_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                rResults.push(value);
              });
              setIBS03RResult(rResults);
              break;
            case "iBS03T":
              const tResults: iBS03T_ResultType[] = [];
              items.data.forEach((value: iBS03T_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                tResults.push(value);
              });
              setIBS03TResult(tResults);
              break;
            case "iBS05H":
              const hResults: iBS05H_ResultType[] = [];
              items.data.forEach((value: iBS05H_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                hResults.push(value);
              });
              setIBS05HResult(hResults);
              break;
            case "iBS03ADV":
              const advResults: iBS03ADV_ResultType[] = [];
              items.data.forEach((value: iBS03ADV_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                advResults.push(value);
              });
              setIBS03ADVResult(advResults);
              break;
            case "salta":
              const saltaResults: salta_ResultType[] = [];
              items.data.forEach((value: salta_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                saltaResults.push(value);
              });
              setSaltaResult(saltaResults);
              break;
            case "iBS03TP":
              const tpResults: iBS03TP_ResultType[] = [];
              items.data.forEach((value: iBS03TP_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                tpResults.push(value);
              });
              setIBS03TPResult(tpResults);
              break;
            case "iBS03F":
              const fResults: iBS03F_ResultType[] = [];
              items.data.forEach((value: iBS03F_ResultType, index: number) => {
                value.no = items.from;
                items.from++;
                fResults.push(value);
              });
              setIBS03FResult(fResults);
              break;
            default:
              // 共通型や他モデルの場合
                alert("モデルを選択して下さい")
          }
        })
        .catch(err =>
          alert("エラーが発生しました。" + err)
        )
        } finally {
          setIsFetching(false);
        }
    }

    // model値に応じてCSV用Result配列を返す関数
    const getCsvResultArray = () => {
      switch(model) {
        case "iBS02IR":
          return iBS02IRCsvResult;
        case "iBS02PIR":
          return iBS02PIRCsvResult;
        case "iBS03R":
          return iBS03RCsvResult;
        case "iBS03T":
          return iBS03TCsvResult;
        case "iBS05H":
          return iBS05HCsvResult;
        case "iBS03ADV":
          return iBS03ADVCsvResult;
        case "salta":
          return saltaCsvResult;
        case "iBS03TP":
          return iBS03TPCsvResult;
        case "iBS03F":
          return iBS03FCsvResult;
        default:
          return []; // 共通型や未選択時
      }
    };
    // model値に応じてset関数を返す関数
    const getSetCsvResult = (): React.Dispatch<React.SetStateAction<any[]>> => {
      switch(model) {
        case "iBS02IR":
          return setIBS02IRCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS02PIR":
          return setIBS02PIRCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03R":
          return setIBS03RCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03T":
          return setIBS03TCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS05H":
          return setIBS05HCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03ADV":
          return setIBS03ADVCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "salta":
          return setSaltaCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03TP":
          return setIBS03TPCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        case "iBS03F":
          return setIBS03FCsvResult as React.Dispatch<React.SetStateAction<any[]>>;
        default:
          return (() => {}) as React.Dispatch<React.SetStateAction<any[]>>;
      }
    };

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("beaconLog");
      const worksheet = workbook.getWorksheet("beaconLog");

      // モデルごとにヘッダーを定義
      let columns: Partial<ExcelJS.Column>[] = [];
      switch(model) {
        case "iBS02IR":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "event", key: "event" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS02PIR":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "event", key: "event" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03R":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "button", key: "button" },
            { header: "distance", key: "distance" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03T":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "button", key: "button" },
            { header: "moving", key: "moving" },
            { header: "hall_sensor", key: "hall_sensor" },
            { header: "temperature", key: "temperature" },
            { header: "humidity", key: "humidity" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS05H":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "hall_sensor", key: "hall_sensor" },
            { header: "count", key: "count" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03ADV":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "voltage", key: "voltage" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "salta":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "deviceType", key: "deviceType" },
            { header: "serial_number", key: "serial_number" },
            { header: "adv_type", key: "adv_type" },
            { header: "angle", key: "angle" },
            { header: "battery", key: "battery" },
            { header: "status", key: "status" },
            { header: "sw2", key: "sw2" },
            { header: "jp4", key: "jp4" },
            { header: "jp3", key: "jp3" },
            { header: "jp2", key: "jp2" },
            { header: "jp1", key: "jp1" },
            { header: "add1", key: "add1" },
            { header: "add2", key: "add2" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03TP":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "button", key: "button" },
            { header: "moving", key: "moving" },
            { header: "hall_sensor", key: "hall_sensor" },
            { header: "temperature", key: "temperature" },
            { header: "probe_temperature", key: "probe_temperature" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        case "iBS03F":
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "app_id", key: "app_id" },
            { header: "manufacturer_id", key: "manufacturer_id" },
            { header: "model", key: "model" },
            { header: "battery", key: "battery" },
            { header: "flood", key: "flood" },
            { header: "triggered_count", key: "triggered_count" },
            { header: "macaddress", key: "macaddress" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" }
          ];
          break;
        default:
          // 共通型や未選択時
          columns = [
            ...(isNoCheck ? [{ header: "no", key: "no" }] : []),
            { header: "id", key: "id" },
            { header: "bundle_id", key: "bundle_id" },
            { header: "device_id", key: "device_id" },
            { header: "beacon_id", key: "beacon_id" },
            { header: "name", key: "name" },
            { header: "rssi", key: "rssi" },
            { header: "detected", key: "detected" },
            { header: "arrived", key: "arrived" },
            { header: "latitude", key: "latitude" },
            { header: "longitude", key: "longitude" },
            { header: "abs_height", key: "abs_height" }
          ];
          break;
      }

      worksheet.columns = columns;

      setIsLoading(true);

      // modelごとにResult配列を取得
      const csvResult = getCsvResultArray();
      const setCSVResult = getSetCsvResult();

      if (await getAllSensorLog(e, 1) === true ) {
        csvResult.forEach((value: any) => {
          worksheet.addRow(value);
        });

        // modelごとに該当するCsvResultのみ初期化
        setCSVResult([]);

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "sensorlog_" + model + "_" + getNowDate() +  ".csv"; //フォーマットによってファイル拡張子を変えている
            a.click();
            a.remove();
          },1000)
        } catch (error) {
          alert(error);
        }
      } else {
        setIsLoading(false);
      }
    }

    // getAllSensorLog内
    const getAllSensorLog = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();

      // modelごとにResult配列とset関数を取得
      let csvResult = getCsvResultArray();
      let setCSVResult = getSetCsvResult();

      await axios.get(apiUrl, {
        headers: {
          "Authorization": apiKey,
          "Content-Type": "application/json"
        },
        params: {
          ...(pageNo ? {page: pageNo} : {}),
          ...({per_page: 10000}),
          ...(model ? {model: model} : {}),
          ...(macaddress ? {macaddress: macaddress} : {}),
          ...(rssi_gt ? {rssi_gt: rssi_gt} : {}),
          ...(rssi_lt ? {rssi_lt: rssi_lt} : {}),
          ...(detected_gt ? {detected_gt: detected_gt.replace("T", " ")} : {}),
          ...(detected_lt ? {detected_lt: detected_lt.replace("T", " ")} : {}),
          ...(arrived_gt ? {arrived_gt: arrived_gt.replace("T", " ")} : {}),
          ...(arrived_lt ? {arrivedLt: arrived_lt.replace("T", " ")} : {}),
          ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          if (pageNo === 1) {
            let result = window.confirm("10万件を超えるデータは出力出来ません\n10万件までのデータを出力しますか？\n総件数:" + items.total + "\n日付範囲を調整して下さい。")
            if (result === false) {
              return ret = false
            }
          }
        } else {
          setLastPageNo(items.last_page)
        }

        let csvArrayCount = csvResult.length;
        // モデルごとに型を分岐して格納
        switch(model) {
          case "iBS02IR":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS02IR_ResultType;
              items.from++;
              (csvResult as iBS02IR_ResultType[]).push(value);
            });
            break;
          case "iBS02PIR":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS02PIR_ResultType;
              items.from++;
              (csvResult as iBS02PIR_ResultType[]).push(value);
            });
            break;
          case "iBS03R":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03R_ResultType;
              items.from++;
              (csvResult as iBS03R_ResultType[]).push(value);
            });
            break;
          case "iBS03T":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03T_ResultType;
              items.from++;
              (csvResult as iBS03T_ResultType[]).push(value);
            });
            break;
          case "iBS05H":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS05H_ResultType;
              items.from++;
              (csvResult as iBS05H_ResultType[]).push(value);
            });
            break;
          case "iBS03ADV":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03ADV_ResultType;
              items.from++;
              (csvResult as iBS03ADV_ResultType[]).push(value);
            });
            break;
          case "salta":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as salta_ResultType;
              items.from++;
              (csvResult as salta_ResultType[]).push(value);
            });
            break;
          case "iBS03TP":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03TP_ResultType;
              items.from++;
              (csvResult as iBS03TP_ResultType[]).push(value);
            });
            break;
          case "iBS03F":
            (items.data as any[]).forEach((item) => {
              const value = { ...item, no: items.from } as iBS03F_ResultType;
              items.from++;
              (csvResult as iBS03F_ResultType[]).push(value);
            });
            break;
          default:
            alert("モデルを選択して下さい")
            break;
        }
        switch(model) {
          case "iBS02IR":
            setCSVResult([...(csvResult as iBS02IR_ResultType[])]);
            break;
          case "iBS02PIR":
            setCSVResult([...(csvResult as iBS02PIR_ResultType[])]);
            break;
          case "iBS03R":
            setCSVResult([...(csvResult as iBS03R_ResultType[])]);
            break;
          case "iBS03T":
            setCSVResult([...(csvResult as iBS03T_ResultType[])]);
            break;
          case "iBS05H":
            setCSVResult([...(csvResult as iBS05H_ResultType[])]);
            break;
          case "iBS03ADV":
            setCSVResult([...(csvResult as iBS03ADV_ResultType[])]);
            break;
          case "salta":
            setCSVResult([...(csvResult as salta_ResultType[])]);
            break;
          case "iBS03TP":
            setCSVResult([...(csvResult as iBS03TP_ResultType[])]);
            break;
          case "iBS03F":
            setCSVResult([...(csvResult as iBS03F_ResultType[])]);
            break;
          default:
            setCSVResult([...csvResult]);
            break;
        }
        console.log("lastPageNo:" + lastPageNo)

        if (items.last_page > 10) {
          if (items.current_page !== 10) {
            await getAllSensorLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        } else {
          if (items.current_page !== items.last_page) {
            await getAllSensorLog(e, items.current_page + 1);
          } else {
            console.log("getall: " + csvResult.length);
          }
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )

      return ret
  }

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_gt(value);
  }
  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setDetcted_lt(value);
  }
  const changeArrivedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_gt(value);
  }
  const changeArrivedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setArrived_lt(value);
  }
  const changePerPage = (value: string) => { setPer_Page(value) }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  const getLastPageNo = () => {
    if (per_page === "") { return 100000 / 100 }
    else { return 100000 / Number(per_page) }
  }

  type sensorParamsType = {
    apikey?: string, macaddress?: string, model?: string, perpage?: string,
    rssigt?: string, rssilt?: string, detectedgt?: string, detectedlt?: string,
    arrivedgt?: string, arrivedlt?: string, sort?: string
  }

  const saveParams = () => {
    let params: sensorParamsType = {};
    params.macaddress = macaddress ? macaddress : "";
    params.perpage = per_page ? per_page : "";
    params.model = model ? model : "";
    params.rssigt = rssi_gt ? rssi_gt : "";
    params.rssilt = rssi_lt ? rssi_lt : "";
    params.detectedgt = detected_gt ? detected_gt : "";
    params.detectedlt = detected_lt ? detected_lt : "";
    params.arrivedgt = arrived_gt ? arrived_gt : "";
    params.arrivedlt = arrived_lt ? arrived_lt : "";
    params.sort = sort ? sort : "";
    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoSensorParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoSensorParams")
    if (paramsJson != null) {
      const params:sensorParamsType = JSON.parse(paramsJson as string)
      setPer_Page(params.perpage ? params.perpage : "")
      setModel(params.model ? params.model : "");
      setMacaddress(params.macaddress ? params.macaddress : "");
      setRssi_gt(params.rssigt ? params.rssigt : "");
      setRssi_lt(params.rssilt ? params.rssilt : "");
      setDetcted_gt(params.detectedgt ? params.detectedgt : "");
      setDetcted_lt(params.detectedlt ? params.detectedlt : "");
      setArrived_gt(params.arrivedgt ? params.arrivedgt : "");
      setArrived_lt(params.arrivedlt ? params.arrivedlt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) { setApikey(locoApikey ? locoApikey : ""); }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
        const secret = JSON.parse(secretJson as string)
        const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
        const option1 = document.createElement("option");
        option1.value = "";
        option1.textContent = "APIKeyを選択して下さい";
        selectApikey?.appendChild(option1)
        secret.forEach((element: { apikey: string; name: string | null; }) => {
            const option1 = document.createElement("option");
            option1.value = element.apikey;
            option1.textContent = element.name;
            selectApikey?.appendChild(option1)
        })
    }
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    model ? { key: "model", label: "Model", value: model, clear: () => setModel("") } : null,
    macaddress ? { key: "mac", label: "MAC", value: macaddress, clear: () => setMacaddress("") } : null,
    rssi_gt ? { key: "rgt", label: "RSSI ≥", value: rssi_gt, clear: () => setRssi_gt("") } : null,
    rssi_lt ? { key: "rlt", label: "RSSI ≤", value: rssi_lt, clear: () => setRssi_lt("") } : null,
    detected_gt ? { key: "dgt", label: "Detected ≥", value: detected_gt, clear: () => setDetcted_gt("") } : null,
    detected_lt ? { key: "dlt", label: "Detected ≤", value: detected_lt, clear: () => setDetcted_lt("") } : null,
    arrived_gt ? { key: "agt", label: "Arrived ≥", value: arrived_gt, clear: () => setArrived_gt("") } : null,
    arrived_lt ? { key: "alt", label: "Arrived ≤", value: arrived_lt, clear: () => setArrived_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page && per_page !== "1000") ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("1000") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setModel(""); setMacaddress(""); setRssi_gt(""); setRssi_lt("");
    setDetcted_gt(""); setDetcted_lt(""); setArrived_gt(""); setArrived_lt("");
    setSort(""); setPer_Page("1000");
  };

  const hasResult =
    iBS02IRResult.length > 0 || iBS02PIRResult.length > 0 || iBS03RResult.length > 0 ||
    iBS03TResult.length > 0 || iBS05HResult.length > 0 || iBS03ADVResult.length > 0 || saltaResult.length > 0 ||
    iBS03TPResult.length > 0 || iBS03FResult.length > 0;

  return (
    <div className="bl-page">
      <Header current_page="Sensor"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title"><Ico name="filter"/> 検索条件</span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="sl-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getSensorLogs(e, 0)}>
            <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
              {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
            </button>
            <div>
              <div className="bl-group-label">接続先・モデル</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">ApiKey</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => setApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">Model</label>
                  <select className="bl-select" name="model" value={model} onChange={(e) => setModel(e.target.value)}>
                    <option value="">モデルを選択してください</option>
                    <option value="iBS02IR">iBS02IR</option>
                    <option value="iBS02PIR">iBS02PIR</option>
                    <option value="iBS03R">iBS03R</option>
                    <option value="iBS03T">iBS03T</option>
                    <option value="iBS05H">iBS05H</option>
                    <option value="iBS03ADV">iBS03ADV</option>
                    <option value="salta">salta</option>
                    <option value="iBS03TP">iBS03TP</option>
                    <option value="iBS03F">iBS03F</option>
                  </select>
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Per_Page</span>
                    <span className="bl-field-hint">既定1000 / 最大10000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => changePerPage(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">識別子</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">macaddress</label>
                  <input className="bl-input bl-mono" type="text" name="macaddress" value={macaddress}
                    placeholder="macaddressを入力" onChange={(e) => setMacaddress(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">RSSI 範囲</div>
              <div className="bl-grid-2">
                <div>
                  <label className="bl-field-label">≥ (gt)</label>
                  <input className="bl-input" type="text" name="rssi_gt" value={rssi_gt}
                    placeholder="例: -80" onChange={(e) => setRssi_gt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">≤ (lt)</label>
                  <input className="bl-input" type="text" name="rssi_lt" value={rssi_lt}
                    placeholder="例: -30" onChange={(e) => setRssi_lt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Detected（ビーコン発見時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降 (gt)</label>
                  <input className="bl-input" type="datetime-local" step="1" autoComplete="on" name="detected_gt"
                    value={detected_gt} onChange={(e) => changeDetectedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前 (lt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="detected_lt"
                    value={detected_lt} onChange={(e) => changeDetectedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Arrived（サーバー到達時刻）</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">以降 (gt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_gt"
                    value={arrived_gt} onChange={(e) => changeArrivedGt(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">以前 (lt)</label>
                  <input className="bl-input" type="datetime-local" step="1" name="arrived_lt"
                    value={arrived_lt} onChange={(e) => changeArrivedLt(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <div className="bl-aside-actions">
              <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
                {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
              </button>
              <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
            </div>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>SensorLog</h2>
              {model && <span className="bl-badge">{model}</span>}
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isFetching || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isFetching || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.length === 0 && <span className="bl-chips-empty">条件は未設定です</span>}
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(total > 0 && hasResult) ? (
              <>
                {iBS02IRResult.length > 0 && <SensorLog_iBS02IR_Result sensorlogs={iBS02IRResult} />}
                {iBS02PIRResult.length > 0 && <SensorLog_iBS02PIR_Result sensorlogs={iBS02PIRResult} />}
                {iBS03RResult.length > 0 && <SensorLog_iBS03R_Result sensorlogs={iBS03RResult} />}
                {iBS03TResult.length > 0 && <SensorLog_iBS03T_Result sensorlogs={iBS03TResult} />}
                {iBS05HResult.length > 0 && <SensorLog_iBS05H_Result sensorlogs={iBS05HResult} />}
                {iBS03ADVResult.length > 0 && <SensorLog_iBS03ADV_Result sensorlogs={iBS03ADVResult} />}
                {saltaResult.length > 0 && <SensorLog_salta_Result sensorlogs={saltaResult} />}
                {iBS03TPResult.length > 0 && <SensorLog_iBS03TP_Result sensorlogs={iBS03TPResult} />}
                {iBS03FResult.length > 0 && <SensorLog_iBS03F_Result sensorlogs={iBS03FResult} />}
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getSensorLogs} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するログがありません" : "SensorLogを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "Modelを選択し、左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isFetching || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "読み込み中…"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default SensorLog